import {
  array,
  arrayOf,
  func,
  node,
  number,
  oneOf,
  oneOfType,
  shape,
  string,
} from "prop-types";

import { useAppContext } from "web/context/app";

import DetailsDesktop from "./Desktop";
import DetailsMobile from "./Mobile";

const CheckoutProductDetails = ({
  categoryId,
  name,
  image,
  additionalInfo,
  classes,
  link,
  children,
  dataT1,
  variant,
}) => {
  const { isMobile } = useAppContext();
  return isMobile ? (
    <DetailsMobile
      name={name}
      image={image}
      additionalInfo={additionalInfo}
      classes={classes}
      link={link}
      dataT1={dataT1}
      variant={variant}
    >
      {children}
    </DetailsMobile>
  ) : (
    <DetailsDesktop
      categoryId={categoryId}
      name={name}
      image={image}
      additionalInfo={additionalInfo}
      classes={classes}
      link={link}
      dataT1={dataT1}
      variant={variant}
    >
      {children}
    </DetailsDesktop>
  );
};

CheckoutProductDetails.propTypes = {
  categoryId: oneOfType([string, number, oneOf([null])]),
  name: string.isRequired,
  image: oneOfType([string, oneOf([null])]),
  additionalInfo: arrayOf(shape({})),
  classes: shape({}),
  link: string.isRequired,
  children: oneOfType([node, string, array, func, shape({}), oneOf([null])]),
  dataT1: string,
};

CheckoutProductDetails.defaultProps = {
  categoryId: null,
  image: null,
  additionalInfo: [],
  children: null,
  dataT1: "details",
  classes: null,
};

export default CheckoutProductDetails;
